import {ChartTypeEnum} from  "@/components/explorer/visualizations/ChartTypeEnum.js"

function setupAppliedValues(indicator) {

	const childColumn = indicator.columns.items.find(x => x.parentColumnName)
	if(childColumn) {
		const parentColumn = indicator.columns.items.find(x => x.columnName == childColumn.parentColumnName)
		if(childColumn.appliedValues == null) {
			childColumn.appliedValues = []
			childColumn.nestedColumns = []
			let sharedGrps = []
			let sharedGrpFullValue = null
 			if(parentColumn) {
				if(parentColumn.distinctValues.length > 0) {
					//if parent contains shared groupings for child dims, then use same child obj for both parent groupings
					parentColumn.distinctValues.forEach(x => {
						let grps = x.split(';').map(v => v.trim())
						if(grps.length > 1) {
							sharedGrpFullValue = x
							//sharedGrps.push([x])
							sharedGrps.push(grps)
						}
					})
				}
			}
			if(childColumn.distinctValues.length > 0) {
				Object.keys(childColumn.distinctValues[0]).forEach(key => {
					//skip blank values
					if(key != "") {
						const values = childColumn.distinctValues[0][key];
						const nestedCol = {}
						nestedCol.name = key
						nestedCol.selected = true
						nestedCol.appliedValues = []
						values.forEach(value => {
							let obj = {}
							obj.name = value
							obj.selected = true
							obj.parentValue = key;
							let foundVal = null
							//If value has already been added to another group then override obj with reference to that object for the current obj
							//This will enable selections made in one grp be reflected in all grps that share the object
							if(sharedGrps.length > 0) {
								sharedGrps.forEach(sharedGrp => {
									if(sharedGrp.includes(key)) {
										//child is shared between parent groups
										//if(key == 'EU-27') {
										nestedCol.sharedGrpFullValue = sharedGrpFullValue
										//}									
										if(childColumn.nestedColumns != null && childColumn.nestedColumns.length > 0) {
											//if shared grp has already been established, use reference to appliedValues items for current grp appliedValues
											childColumn.nestedColumns.forEach(grouping => {
												if(sharedGrp.includes(grouping.name)) {
													foundVal = childColumn.appliedValues.find(x => {
														return x.name == value
													})
													if(foundVal)
														obj = foundVal
												}
											})
										}
									}
								})
							}
							if(foundVal == null) {
								childColumn.appliedValues.push(obj)
							}
							nestedCol.appliedValues.push(obj)
						})
						childColumn.nestedColumns.push(nestedCol)					
					}
				});
				
				childColumn.appliedValues = childColumn.appliedValues.sort((a, b) => {
					const nameA = a.name.toUpperCase();
					const nameB = b.name.toUpperCase();
					if (nameA < nameB) {
						return -1; // nameA comes first
					}
					if (nameA > nameB) {
						return 1; // nameB comes first
					}
					return 0; // names must be equal
				})
			}
			if(parentColumn) {
				parentColumn.childColumnName = childColumn.columnName
 				// if(childColumn.subtotalValues != null && childColumn.subtotalValues.length > 0){
				// 	parentColumn.includeParentFlag = true
				// } else {
				// 	parentColumn.includeParentFlag = false
				// }
				parentColumn.parentFlag = 0
				parentColumn.appliedValues = childColumn.nestedColumns
				//add shared groups full name - required for API requests
				parentColumn.distinctValues.forEach(x => {
					if(x.includes(';')) {
						let obj = {}
						obj.name = x
						obj.selected = true
						//obj.appliedValues = []
						parentColumn.appliedValues.push(obj)
					}
				})
			}
			//reorder values so subtotal is 1st
			if(childColumn.subtotalValues != null && childColumn.subtotalValues.length > 0) {
				childColumn.nestedColumns.forEach(parent => {
					if(parent.appliedValues) {
						let ind = parent.appliedValues.findIndex(val => {
							return childColumn.subtotalValues.includes(val.name)
						})
						if(ind > 0) { //move subtotal if not in 1st pos
							let obj = parent.appliedValues.splice(ind, 1)
							parent.appliedValues.unshift(obj[0])
						}
					}
				})
			}
		}
	}

	//Select values for all non-hierarchical categories
	indicator.columns.items.forEach((col) => {
		if(childColumn == null || col.columnName != childColumn.columnName && col.columnName != childColumn.parentColumnName) {
			if(col.categoryLabelFlag || col.xAxisFlag) {
				if(col.appliedValues == null) {
					col.appliedValues = []
					col.distinctValues.forEach(i => {
						let obj = {}
						obj.name = i
						obj.selected = true
						col.appliedValues.push(obj)
					})

					//const defaultVals = col.defaultValues.filter(x => col.distinctValues.includes(x))
					//determin defaultValues type which will be either an array of strings on an array of objects (hierarchies)
					let defaultVals = []
					let type = typeof col.distinctValues[0]
					if(type == 'string') {
						defaultVals = col.defaultValues.filter(x => col.distinctValues.includes(x))
					} else {
						//object so filter on property names
						let allVals = []
						for(let x in col.distinctValues[0]) { allVals.push(x)}
						defaultVals = col.defaultValues.filter(x => allVals.includes(x))
					}
					if(defaultVals.length > 0) {
						col.appliedValues.forEach(i => {
							i.selected = defaultVals.includes(i.name)
						})
					}
				}
				//reorder values so total value is 1st
				if(col.totalLabel != null && col.totalLabel != '') {
					let ind = col.appliedValues.findIndex(val => col.totalLabel == val.name)
					if(ind > 0) { //move subtotal if not in 1st pos
						let obj = col.appliedValues.splice(ind, 1)
						col.appliedValues.unshift(obj[0])
					}
				}

			}
		}
	})
	return
}

function applyRequestFilters(indicator, type, req) {
	let prop, colName
	switch (type) {
		case ChartTypeEnum.BAR.chartName:
		case ChartTypeEnum.BARS.chartName:
		case ChartTypeEnum.BARH.chartName:
		case ChartTypeEnum.BARHS.chartName:
		case ChartTypeEnum.LINE.chartName:
		case ChartTypeEnum.TREEMAP.chartName:
		case ChartTypeEnum.SANKEY.chartName:
			prop = "categories"
			colName = "categoryName"
			break;
		case ChartTypeEnum.MAP.chartName:
		case ChartTypeEnum.TABLE.chartName:
			prop = "columns"
			colName = "columnName"
			break;
		// ... more cases ...
		default:
			prop = "categories"
			colName = "categoryName"
	}
	req[prop].forEach(reqCol => {
		const col = indicator.columns.items.find(x => x.columnName == reqCol[colName] )
		if(col) {
			col.appliedValues.forEach(i => {
				const filter = reqCol.filters.find(x => x == i.name)
				if(filter === i.name)
					i.selected = true;
				else
					i.selected = false;
			})
		}
	})
	return
}

function validateRequestValues(obj, indicator, type) {
	let missingDimension = false
	let deprecatedValue = false
	let additionalValueAvailable = false

	let prop
	switch (type) {
		case ChartTypeEnum.BAR.chartName:
		case ChartTypeEnum.LINE.chartName:
		case ChartTypeEnum.TREEMAP.chartName:
		case ChartTypeEnum.SANKEY.chartName:
			prop = "categories"
			break;
		case ChartTypeEnum.MAP.chartName:
		case ChartTypeEnum.TABLE.chartName:
			prop = "columns"
			break;
		// ... more cases ...
		default:
			prop = "categories"
	}

	if(prop == "categories") {
		if(obj.request.xAxis == null)
			missingDimension = true;
		else
			missingDimension = indicator.columns.items.find(col => col.columnName == obj.request.xAxis) != null?false:true

		if(missingDimension) {
			obj.request.xAxis = indicator.columns.items.find(col => col.categoryLabelFlag == 1 && col.columnName == 'Year').columnName
		}
	}

	obj.request[prop].forEach(reqCat => {
		const matchCol = indicator.columns.items.find(col => col.columnName == reqCat.categoryName);
		if (matchCol) {
			if(matchCol.parentColumnName) {
				let tmpFilters = []
				for (const key in matchCol.distinctValues[0]) {
					tmpFilters = tmpFilters.concat(matchCol.distinctValues[0][key])
				}
				//get distinct values using Set then expand values into array
				const valueSet = new Set(tmpFilters); // fast lookup
				//const totalValues = [... new Set(tmpFilters)];
				let foundValues = reqCat.filters.filter(value => valueSet.has(value));
				if(reqCat.filters.length != foundValues.length) {
					deprecatedValue = true
					reqCat.filters = foundValues
				}
			} else {
				const valueSet = new Set(matchCol.distinctValues); // fast lookup
				let foundValues = reqCat.filters.filter(value => valueSet.has(value));
				if(reqCat.filters.length != foundValues.length) {
					deprecatedValue = true
					reqCat.filters = foundValues
				}
				if(reqCat.categoryName == obj.request.xAxis && foundValues.length < matchCol.distinctValues.length) {
					additionalValueAvailable = true
				}
			}
		}
	});
	return {missingDimension: missingDimension, deprecatedValue: deprecatedValue, additionalValueAvailable: additionalValueAvailable}
}
function buildRequest(indicatorObj, chartSettings, yValue, allFilters) {
	let request = {
		"datasetName": indicatorObj.indicatorName,
		"categories": [],
		"valuesLabel": yValue,
		"xAxis": chartSettings.xAxisDim.columnName
	}

 	allFilters.forEach(col => {
		let cat = {}
		cat.categoryName = col.columnName
		//default all series values to selected
		cat.selected = col.columnName == chartSettings.seriesDim.columnName?true:false;
		let selectedVals = []

		if(col.columnName == chartSettings.xAxisDim.columnName) {
			col.appliedValues.forEach(s => {
				if(s.selected) {
					selectedVals.push(s.name)
				}
			})
		// } else if(col.columnName == chartSettings.seriesDim.columnName && ['treemap','sankey'].includes(chartSettings.type)) {
		// 	col.appliedValues.forEach(s => {
		// 		if(s.selected) {
		// 			selectedVals.push(s.name)
		// 		}
		// 	})
		} else if(col.parentColumnName != null && col.parentColumnName == chartSettings.xAxisDim.columnName &&
			col.columnName != chartSettings.seriesDim.columnName) {
			//column is part of a hierarchy where the parent dim is the series
			if(col.subtotalValues != null && col.subtotalValues.length > 0) {
				col.appliedValues.forEach(x => {
					if(col.subtotalValues.includes(x.name)) {
						if(x.selected) {
							selectedVals.push(x.name)
							//x.selected = true
						}
					} 
					else {
						x.selected = false
					}
				})
			} else {
				col.appliedValues.forEach(s => {
					if(s.selected) {
						selectedVals.push(s.name)
					}
				})
			}
		} else if(col.parentColumnName != null && col.parentColumnName == chartSettings.seriesDim.columnName) {
			//column is part of a hierarchy where the parent dim is the series
			//nested dims can have subtotals defined on the child dim which are the values used when the parent dim is the series
			if(col.subtotalValues != null && col.subtotalValues.length > 0) {
				col.appliedValues.forEach(x => {
					if(col.subtotalValues.includes(x.name)) {
						//if(x.selected) {
						selectedVals.push(x.name)
						x.selected = true;
						//}
					} 
					else {
						x.selected = false
					}						
				})
			} else {
				col.appliedValues.forEach(s => {
					if(s.selected) {
						selectedVals.push(s.name)
					}
				})
			}
		} else if(col.parentColumnName != null && col.columnName == chartSettings.seriesDim.columnName) {
			//column is part of hierarchy where the child dim is the series
			//include all values, disable the subtotal values on initial display of chart
			col.appliedValues.forEach(s => {
				if(s.selected) {
					selectedVals.push(s.name)
				}
			})
		} else if(col.childColumnName != null && col.childColumnName == chartSettings.seriesDim.columnName) {
			//column is part of hierarchy where child is series dim and parent is not used in maps, so include all parent values by not filtering request on parent
			col.appliedValues.forEach(s => {
				if(s.selected) {
					selectedVals.push(s.name)
				}
			})
		} else if(col.childColumnName != null && col.columnName == chartSettings.seriesDim.columnName) {
			//column is part of hierarchy where parent is series dim, so include all parent values
			col.appliedValues.forEach(s => {
				if(s.selected) {
					selectedVals.push(s.name)
				}
			})
		}
		else if(col.childColumnName != null) {
			//column is parent in hierarchy where child is not xaxis nor series dim, so include all parent values by not filtering request on parent
			//skipCol = true;
			col.appliedValues.forEach(s => {
				//if(s.selected) {
					selectedVals.push(s.name)
					s.selected = true
				//}
			})
		} 
		else if(col.columnName == chartSettings.seriesDim.columnName) {
			//this statement will handle all non-hierarchy series dims
			col.appliedValues.forEach(s => {
				if(s.selected) {
					selectedVals.push(s.name)
				}
			})			
		} else {
			//if all visible values are unselected and defaultValues exist set filter to defaultValues, if no defaultValues
			// then check if totalsValue exist, if so set filter to totalsValue.
			//const defaultVals = col.defaultValues.filter(x => col.appliedValues.find(y => y.name.trim() == x.trim()))
			//determin defaultValues type which will be either an array of strings on an array of objects (hierarchies)
			let defaultVals = []
			let type = typeof col.distinctValues[0]
			if(type == 'string') {
				defaultVals = col.defaultValues.filter(x => col.distinctValues.includes(x))
			} else {
				//object so filter on property names
				col.defaultValues.forEach(x => {
					if(col.appliedValues.find(y => y.name == x))
						defaultVals.push(x)
				})				
			}

			const dataVals = col.appliedValues.filter(s => s.selected)
			let allVal = col.totalLabel
			const totalLabelFound = col.appliedValues.find(x => x.name == allVal)
			if(dataVals.length == 1) {
				selectedVals.push(dataVals[0].name)
			} else if (defaultVals.length > 0) {
				//use default value is no vals selected
				selectedVals.push(defaultVals[0])
			} else if(totalLabelFound) {
				selectedVals.push(allVal)
			} else {
				//no selected value, no default, and no Totals defined, so select a single value as the default
				//if the columnName = Year on Sankey & Treemap charts then use the last value
				if (col.columnName === 'Year'  && (chartSettings.type == ChartTypeEnum.TREEMAP.chartName || chartSettings.type == ChartTypeEnum.SANKEY.chartName)) {
					selectedVals.push(col.appliedValues[col.appliedValues.length - 1].name)
				} else {
					//otherwise use the first value
					selectedVals.push(col.appliedValues[0].name)
				}
			}
			//sync appliedValues with latest selectedVals so filter panel dim total selected show the correct counts
			col.appliedValues.forEach(x => {
				if(selectedVals.includes(x.name)) {
					x.selected = true
				} else {
					x.selected = false
				}
			})
		}
		cat.filters = selectedVals
		request.categories.push(cat)
	})
	return request
}
export {setupAppliedValues, applyRequestFilters, validateRequestValues, buildRequest}
